import { createContext, ReactNode, useContext, useMemo } from 'react';

const ConfigContext = createContext<IconLibraryConfig | undefined>(undefined);

type ConfigProviderProps = {
  children: ReactNode;
} & Partial<IconLibraryConfig>;

function ConfigProvider({
  children,
  svgFillColors = '',
  defaultSvgFillColor = '',
  svgBackgroundColors = '',
  defaultSvgBackgroundColor = '',
  searchCategories = '',
  listItemStyles = '',
  realm,
  pngOutputSizes = '',
}: ConfigProviderProps) {
  const value = useMemo(
    () => ({
      svgFillColors,
      defaultSvgFillColor,
      svgBackgroundColors,
      defaultSvgBackgroundColor,
      searchCategories,
      listItemStyles,
      realm,
      pngOutputSizes,
    }),
    [
      svgFillColors,
      defaultSvgFillColor,
      svgBackgroundColors,
      defaultSvgBackgroundColor,
      searchCategories,
      listItemStyles,
      realm,
      pngOutputSizes,
    ],
  );
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

function useConfig() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error(`useConfig must be used within a ConfigProvider`);
  }
  return context;
}

export { ConfigProvider, useConfig };
